import React, { ChangeEvent, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import CompanyName from '../../commonComponents/CompanyName';
import { CompanyNameType } from '../../../static/types/commonTypes/companyNameType';
import useAppContext from '../../../hooks/useAppContext';
import { AppContextType } from '../../../context/AppContext';
import LegalEntity from '../../commonComponents/LegalEntity';
import { LegalEntityType } from '../../../static/types/commonTypes/legalEntityType';
import { DecisionType } from '../../../static/types/commonTypes/decisionType';
import DateComponent from '../../commonComponents/DateComponent';
import { DateType } from '../../../static/types/commonTypes/dateType';
import ReducedManager from '../../commonComponents/ReducedManager';
import { initialReducedManagerState } from '../../../static/initialState/commonInitialState/initialReducedManagerState';
import DecisionWithQuality from '../../commonComponents/DecisionWithQuality';
import { ManagerTypeWithQualite } from '../../../static/types/commonTypes/managerType';
import { getCityWithPreposition } from '../../../utils/functions/getCityWithPreposition';
import IndividualPersonList from '../../commonComponents/IndividualPersonList';
import { IndividualPersonType } from '../../../static/types/commonTypes/individualType';
import { ReducedManagerType } from '../../../static/types/commonTypes/reducedManagerType';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import { formatObjectText } from '../../../utils/functions/formatObjectText';


interface AnnonceProps {
    txtAnnonce: string;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    activeIndex: number;
    updateActiveIndex: (index: number) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;
}

const TransformationSASenSARL: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,

}) => {

    const {
        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        legalEntity, setLegalEntity,
        legalEntityValidity, setLegalEntityValidity,
        legalEntityChecked, setLegalEntityChecked,

        decisionWithQuality, setDecisionWithQuality,
        decisionWithQualityValidity, setDecisionWithQualityValidity,
        decisionWithQualityChecked, setDecisionWithQualityChecked,

        date, setDate,
        setDateValidity,
        dateChecked,

        individualPersons,
        setIndividualPersons,
        individualPersonsValidity,
        setIndividualPersonsValidity,
        individualPersonsChecked,
        setIndividualPersonsChecked,

        typeTransformationOfSocietySARL,
        setTypeTransformationOfSocietySARL,

        auditorChange, setAuditorChange,

        formerStatutoryAuditor, setFormerStatutoryAuditor,
        formerStatutoryAuditorValidity, setFormerStatutoryAuditorValidity,
        formerStatutoryAuditorChecked, setFormerStatutoryAuditorChecked,

        formerAlternateAuditor, setFormerAlternateAuditor,
        formerAlternateAuditorValidity, setFormerAlternateAuditorValidity,
        formerAlternateAuditorChecked, setFormerAlternateAuditorChecked,
        typeFormerAlternateAuditorData, setTypeFormerAlternateAuditorData,

    } = useAppContext() as AppContextType

    const [activeTab, setActiveTab] = useState<string>('companyName');
    const [visitedTabs, setVisitedTabs] = useState(['companyName']);
    const [submissive, setSubmissive] = useState<boolean>(false);

    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType];

    const firstPartDecision = [
        "AG Extraordinaire",
        "AG Ordinaire",
        "AG Mixte"
    ]

    const handleSubmit = (e: React.FormEvent) => {

        e.preventDefault();

        if (validate()) {

            const decisionChange = decisionWithQuality.decisionNature === "AG Extraordinaire"
                ? "AGE"
                : decisionWithQuality.decisionNature === "AG Ordinaire"
                    ? "AGO"
                    : decisionWithQuality.decisionNature === "AG Mixte"
                        ? "AG Mixte"
                        : decisionWithQuality.decisionNature

            const decisionText = firstPartDecision.includes(decisionWithQuality.decisionNature) ? `Aux termes de l'${decisionChange} en date du ${decisionWithQuality.decisionDate} ${decisionWithQuality.decisionQuality.toLowerCase()} ${decisionWithQuality.decisionQuality.toLocaleLowerCase().includes("les") ? "ont" : "a"} décidé de transformer la société en ${typeTransformationOfSocietySARL}` : `Le ${decisionWithQuality.decisionDate}, ${decisionWithQuality.decisionNature.toLowerCase()} a décidé de transformer la société en ${typeTransformationOfSocietySARL}`;

            const individualText = (individual: IndividualPersonType): string => {
                return individual.lastName ? ` ${individual.civility === 'Monsieur' ? 'M.' : 'Mme'} ${individual.lastName} ${individual.firstName}, demeurant ${individual.address} ${individual.additionalAddress ?? ""} ${individual.postalCode} ${individual.city}` : ``
            }


            const reducedManagerText = (manager: ReducedManagerType): string => {
                if (manager.person === "Personne physique") {
                    return ` ${manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${manager.personDetails.lastName} ${manager.personDetails.firstName}`
                }
                else if (manager.person === "Personne morale") {
                    return `${manager.entityDetails.companyName}`
                }
                else return ''
            }

            const auditorText = (): string => {
                let res = ``

                if( auditorChange === 1 ){
                    res = typeFormerAlternateAuditorData === 1
                        ? `Les Commissaires aux comptes titulaire et suppléant, respectivement ${reducedManagerText(formerStatutoryAuditor)} et ${reducedManagerText(formerAlternateAuditor)}, ont été maintenus dans leurs fonctions.`
                        : `Le Commissaire aux comptes titulaire, ${reducedManagerText(formerStatutoryAuditor)}, a été maintenu dans ses fonctions.`
                }
                else if( auditorChange === 2 ){
                    res = typeFormerAlternateAuditorData === 1
                        ? `Suite à la transformation, il est mis fin aux fonctions des Commissaires aux comptes titulaire et suppléant, ${reducedManagerText(formerStatutoryAuditor)} et ${reducedManagerText(formerAlternateAuditor)}.`
                        : `Suite à la transformation, il est mis fin aux fonctions du Commissaire aux comptes titulaire, ${reducedManagerText(formerStatutoryAuditor)}.`
                }
                return res
            }


            const tempText = `${legalEntity.companyName},
${legalEntity.legalForm} au capital de ${legalEntity.capital} €.
Siège social :
${legalEntity.address} ${legalEntity.additionalAddress ?? ""} ${legalEntity.postalCode} ${legalEntity.city}
${legalEntity.rcs} RCS ${getCityWithPreposition(legalEntity.registrationOffice)}.
${decisionText}, sans création d'un être moral nouveau${date.date ? `, à compter du ${date.date}` : ``} et a nommé ${individualPersons.length > 1 ? 'co-gérants' : 'gérant'} ${individualPersons.map((individual: IndividualPersonType) => individualText(individual)).join(" et ")}.
${auditorText()}.
Modification du RCS ${getCityWithPreposition(legalEntity.registrationOffice)}.`

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName);
            setSubmissive(true)
        }
    };

    const auditorValidity = (): boolean => {

        let res = false

        if ( auditorChange === 0 ) res = true
        
        else if ( auditorChange ===  1 || auditorChange ===  2 ) {
            if( typeFormerAlternateAuditorData === 1 ){
                if(  formerStatutoryAuditorValidity && formerAlternateAuditorValidity ) res = true
            }
            else if (formerStatutoryAuditorValidity) res = true
        }

        return res
    }

    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab('companyName')
        } else if (!legalEntityValidity) {
            setActiveTab('theSociety')
        } else if (!decisionWithQualityValidity) {
            setActiveTab('decision')
        } else if (!individualPersonsValidity) {
            setActiveTab ('theManager')
        } else if (auditorChange === 0) {
            setActiveTab('auditor')
        } else if ( auditorChange === 1 || auditorChange === 2 ) {
            if( typeFormerAlternateAuditorData === 1 ){
                if( !( formerStatutoryAuditorValidity && formerAlternateAuditorValidity )) setActiveTab('auditor')
            }
            else if (!formerStatutoryAuditorValidity) setActiveTab('auditor')
        }

        let tempAuditorValidation = auditorValidity()


        return companyNameValidity && legalEntityValidity && decisionWithQualityValidity && individualPersonsValidity && tempAuditorValidation;
    }

    const handleNext = () => {
        if (activeTab === "companyName") {
            setCompanyNameChecked(true)
            if (companyNameValidity) {
                switchTab(getNextTab("companyName"));
            }
        } else if (activeTab === "theSociety") {
            setLegalEntityChecked(true)
            if (legalEntityValidity) {
                switchTab(getNextTab("theSociety"));
            }
        } else if (activeTab === "decision") {
            setDecisionWithQualityChecked(true)
            if (decisionWithQualityValidity) {
                switchTab(getNextTab("decision"));
            }
        } else if (activeTab === "transformationSAS-SARL/EURL") {
            switchTab(getNextTab("transformationSAS-SARL/EURL"));
        } else if (activeTab === "date") {
            switchTab(getNextTab("date"));
        } else if (activeTab === "theManager") {
            setIndividualPersonsChecked(true)
            if (individualPersonsValidity) {
                switchTab(getNextTab("theManager"))
            }
        } else if (activeTab === "auditor") {
            if (auditorChange === 1) {
                setFormerStatutoryAuditorChecked( true )
                if( typeFormerAlternateAuditorData === 1 ){
                    setFormerAlternateAuditorChecked( true )
                    if( formerStatutoryAuditorValidity && formerAlternateAuditorValidity ) setSubmissive( true )
                }
                else if( formerStatutoryAuditorValidity ) setSubmissive( true )
            } else if (auditorChange === 2) {
                setFormerStatutoryAuditorChecked( true )
                if( typeFormerAlternateAuditorData === 1 ){
                    setFormerAlternateAuditorChecked( true )
                    if( formerStatutoryAuditorValidity && formerAlternateAuditorValidity ) setSubmissive( true )
                }
                else if (formerStatutoryAuditorValidity) setSubmissive(true)
            } else setSubmissive(true)
        }

    };
    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false);
    };

    const getNextTab = (currentTab: string) => {
        if (currentTab === "companyName") return "theSociety";
        else if (currentTab === "theSociety") return "decision";
        else if (currentTab === "decision") return "transformationSAS-SARL/EURL";
        else if (currentTab === "transformationSAS-SARL/EURL") return "date";
        else if (currentTab === "date") return "theManager";
        else if (currentTab === "theManager") return "auditor";
        else return currentTab;
    };

    const getPreviousTab = (currentTab: string) => {
        if (currentTab === "auditor") return "theManager";
        else if (currentTab === "theManager") return "date";
        else if (currentTab === "date") return "transformationSAS-SARL/EURL";
        else if (currentTab === "transformationSAS-SARL/EURL") return "decision";
        else if (currentTab === "decision") return "theSociety";
        else if (currentTab === "theSociety") return "companyName";
        else return currentTab;
    };

    const goToSupportPresse = () => {
        updateActiveIndex(2);
    }

    const switchTab = (tab: string) => {
        setActiveTab(tab);
    };


    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...data });

    const updateDecision = (data: Partial<DecisionType>) => setDecisionWithQuality({ ...decisionWithQuality, ...data });

    const updateDate = (data: Partial<DateType>) => setDate({ ...date, ...data });

    const handleToggleAuditorsChange = ( event: ChangeEvent<HTMLSelectElement> ) => {

        setAuditorChange(Number(event.target.value))
        setSubmissive( false )
    
        setFormerStatutoryAuditor (initialReducedManagerState)
        setFormerStatutoryAuditorValidity (false)
        setFormerStatutoryAuditorChecked (false)
    
        setFormerAlternateAuditor (initialReducedManagerState)
        setFormerAlternateAuditorValidity (false)
        setFormerAlternateAuditorChecked (false)
        setTypeFormerAlternateAuditorData (0)
    }
        
    const changeOption: string[] = ['SARL','SARL à capital variable','EURL']

    const tabs =[
        {key: 'companyName', label: 'Raison Sociale'},
        {key: 'theSociety', label: 'La société'},
        {key: 'decision', label: 'La décision'},    
        {key: 'transformationSAS-SARL/EURL', label: 'Transformation SAS en SARL / EURL'},
        {key: 'date', label: 'A compter du'},
        {key: 'theManager', label: 'Le(s) Gérant(s)'},
        {key: 'auditor', label: 'Commissaires aux comptes'},
        
    ]

    return (
        <>
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                    </ul>
                </div>

            <ToastContainer />

            <form onSubmit={handleSubmit}>
                {
                    activeTab === 'companyName' &&
                    <div>
                        <span className='mb-2'>
                            Indiquer la raison sociale de la société ou la dénomination du Cabinet de Notaire annonceur ou l'état civil de la personne concernée par l'annonce, en optionnel vous pouvez ajouter une référence client.
                        </span>
                        <div className="tab-content">
                            <CompanyName
                                changeCompanyName={updateCompanyName}
                                checked={companyNameChecked}
                                companyName={companyName}
                                onValidationChange={(isValid: boolean) => setCompanyNameValidity(isValid)}
                                showClientReference={true}
                            />
                        </div>
                    </div>
                }

                {
                    activeTab === 'theSociety' &&
                    <LegalEntity
                        changeLegalEntity={(partialData: Partial<LegalEntityType>) => setLegalEntity({ ...legalEntity, ...partialData })}
                        checked={legalEntityChecked}
                        legalEntity={legalEntity}
                        onValidationChange={(isValid: boolean) => setLegalEntityValidity(isValid)}
                        companyName={companyName}
                        setCompanyName={(partialData: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...partialData })}
                        societyType={societyTypeOptions}
                        draftFieldName = 'legalEntity'
                    />
                }

                {
                    activeTab === 'decision' &&
                    <DecisionWithQuality
                        decisionWithQuality={decisionWithQuality}
                        draftFieldName = 'decisionWithQuality'
                        checked={decisionWithQualityChecked}
                        dateLabel='Date'
                        changeDecision={updateDecision}
                        onValidationChange={(isValid: boolean) => setDecisionWithQualityValidity(isValid)}
                        decisionQualityOptions={[
                            "L'associé unique",
                            "Les associés",
                            "Les actionnaires"
                        ]}
                        decisionNatureOptions={[
                            "AG Extraordinaire",
                            "AG Ordinaire",
                            "AG Mixte",
                            "Le gérant",
                            "Le président",
                            "Le conseil d'administration",
                            "Décision unanime des associés"
                        ]}
                    />
                }

                {
                    activeTab === 'transformationSAS-SARL/EURL' &&
                    <div >
                        <div className='col-sm-10 d-flex align-items-center mt-1'>
                            <label htmlFor="modification" className="col-sm-auto col-form-label me-2">
                                Transformation en <strong className="text-danger">*</strong>
                            </label>
                            <select
                                className='form-select w-75'
                                id="modificationCAC"
                                onChange={(e) => {
                                    setTypeTransformationOfSocietySARL(e.target.value)
                                }}
                                value={typeTransformationOfSocietySARL}
                            >
                                {
                                    changeOption.map((value, key) => <option value={value} key={key}>{value}</option>)
                                }
                            </select>
                        </div>
                    </div>
                }

                {
                    activeTab === 'date' &&
                    <DateComponent
                        dateLabel="Date d'effet"
                        date={date}
                        checked={dateChecked}
                        changeDate={updateDate}
                        required={false}
                        onValidationChange={(isValid: boolean) => setDateValidity(isValid)}
                        id='dateEffetSASenSARL'
                    />
                }

                {
                    activeTab === 'theManager' &&
                    // A modifier pour EntityList
                    <IndividualPersonList
                        checked={individualPersonsChecked}
                        individuals={individualPersons}
                        setIndividuals={setIndividualPersons}
                        setIndividualsValidity={setIndividualPersonsValidity}
                        addButtonText='Ajouter un gérant'
                        removeButtonText='Supprimer le dernier gérant'
                    />
                }

                {
                    activeTab === 'auditor' && 
                        <div>
                            <span>
                                La société avait-elle des commissaires aux comptes avant la transformation ?
                            </span>
                            <div className='col-sm-10 d-flex align-items-center mt-1'>
                                <label htmlFor="modification" className="col-sm-2 col-form-label mb-0">
                                    Existence de CAC
                                </label>
                                <select
                                    className='form-select w-75'
                                    id='person'
                                    onChange={handleToggleAuditorsChange}
                                    value= {auditorChange}
                                >
                                    <option value={0}>Non et pas de nomination</option>
                                    <option value={1}>Oui et ils sont maintenus</option>
                                    <option value={2}>Oui et ils ne sont pas maintenus</option>
                                </select>
                            </div>
                            {
                                auditorChange !== 0 &&
                                <div>
                                    <div className='mt-3'>
                                        <h6 className='text-bold'>
                                            Commissaire aux comptes titulaire
                                        </h6>
                                            <ReducedManager
                                                checked = { formerStatutoryAuditorChecked }
                                                manager = { formerStatutoryAuditor }
                                                draftFieldName = 'formerStatutoryAuditor'
                                                setChecked = { setFormerStatutoryAuditorChecked }
                                                setManager = { setFormerStatutoryAuditor }
                                                updateManagerValidity = {( isValid ) => setFormerStatutoryAuditorValidity ( isValid )}
                                            />
                                    </div>
                                    <div className='row align-items-center mt-3'>
                                        <h6 className='text-bold'>
                                            Commissaire aux comptes suppléant
                                        </h6>
                                        <div className="col-sm-10">
                                            <select
                                                className="form-select w-25"
                                                id="person"
                                                onChange = {( event ) => {
                                                    setFormerAlternateAuditor (initialReducedManagerState)
                                                    setTypeFormerAlternateAuditorData(Number(event.target.value))
                                                    setSubmissive( false )
                                                }}
                                                value = { typeFormerAlternateAuditorData }
                                            >
                                                    <option value={1}> Oui </option>
                                                    <option value={0}> Non </option>
                                            </select>
                                        </div>
                                        {
                                            typeFormerAlternateAuditorData === 1 &&
                                            <div>
                                                <div className='mt-3'>
                                                    <ReducedManager
                                                        manager = { formerAlternateAuditor }
                                                        draftFieldName = 'formerAlternateAuditor'
                                                        setManager = { setFormerAlternateAuditor }
                                                        setChecked = { setFormerAlternateAuditorChecked }
                                                        checked = { formerAlternateAuditorChecked }
                                                        updateManagerValidity = {( isValid ) => setFormerAlternateAuditorValidity ( isValid )}
                                                    />
                                                </div>
                                        </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                }

                {
                    submissive &&
                    activeTab === 'auditor' &&
                    <div className="mt-4">
                        <h4>Texte de l'annonce:</h4>
                        <textarea
                            className="form-control"
                            rows={5}
                            value={txtAnnonce}
                            disabled
                        />
                    </div>
                }

                <div className="button-container">
                    <div className="d-flex gap-2">
                        {
                            activeTab !== 'companyName' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handlePrevious} >
                                    <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                    Modifier mon annonce
                                </button>
                            )}

                        {
                            activeTab === 'auditor' && (
                                <button type="submit"
                                    onClick={handleNext}>
                                    Mettre à jour mon annonce
                                    <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                                </button>
                            )}

                        {
                            activeTab !== 'auditor' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handleNext} >
                                    Suivant
                                    <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}

                        {
                            submissive && activeTab === 'auditor' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={goToSupportPresse} >
                                    Sélection du support
                                    <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}
                    </div>
                </div>
            </form>
        </>
    );
};

export default TransformationSASenSARL;